export const DB_NAME = "DELI_ELECTRON_DB";
export const DB_VERSION = 1;